var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChildlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5833 8.59961H10.5958M18.0833 8.59961H18.0958M10.0023 13.5996C10.8668 15.0941 12.4827 16.0996 14.3333 16.0996C16.1841 16.0996 17.7999 15.0941 18.6644 13.5996M14.3333 21.0996C18.9929 21.0996 22.9082 17.9127 24.0183 13.5996H24.3333C25.7141 13.5996 26.8333 12.4804 26.8333 11.0996C26.8333 9.71886 25.7141 8.59961 24.3333 8.59961H24.0183C22.9082 4.28655 18.9929 1.09961 14.3333 1.09961C9.67371 1.09961 5.75846 4.28655 4.64836 8.59961H4.33331C2.9526 8.59961 1.83331 9.71886 1.83331 11.0996C1.83331 12.4804 2.9526 13.5996 4.33331 13.5996H4.64836C5.75846 17.9127 9.67371 21.0996 14.3333 21.0996Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildlight);
export default __webpack_public_path__ + "static/media/childlight.06a20c609c0c08404f29297ee52e1323.svg";
export { ForwardRef as ReactComponent };